import { Action } from '@ngrx/store';
import { QueryParamsModel } from '../../_base/crud';
import { FollowupReason } from '../_models/followup-reason.model';

export enum FollowupReasonActionTypes {
  FollowupReasonOnServerDeleted = '[Followup Reasons] Followup Reason On Server Deleted',
  FollowupReasonDeleted = '[Followup Reasons] Followup Reason Deleted',
  FollowupReasonsPageRequested = '[Followup Reasons] Followup Reasons Page Requested',
  FollowupReasonsPageLoaded = '[Followup Reasons] Followup Reasons Page Loaded',
  FollowupReasonsPageCancelled = '[Followup Reasons] Followup Reasons Page Cancelled',
  FollowupReasonsPageToggleLoading = '[Followup Reasons] Followup Reasons Page Toggle Loading',
  FollowupReasonsActionToggleLoading = '[Followup Reasons] Followup Reasons Action Toggle Loading',
  ThrowFollowupReasonError = '[Followup Reasons] Throw Error',
  FireFollowupReasonSuccess = '[Followup Reasons] Fire Success',
}

export class ThrowFollowupReasonError implements Action {
  readonly type = FollowupReasonActionTypes.ThrowFollowupReasonError;

  constructor(public payload: { error: any }) {}
}

export class FireFollowupReasonSuccess implements Action {
  readonly type = FollowupReasonActionTypes.FireFollowupReasonSuccess;

  constructor(public payload: { action_type: string }) {}
}

export class FollowupReasonOnServerDeleted implements Action {
  readonly type = FollowupReasonActionTypes.FollowupReasonOnServerDeleted;

  constructor(public payload: { id: number }) {}
}

export class FollowupReasonDeleted implements Action {
  readonly type = FollowupReasonActionTypes.FollowupReasonDeleted;

  constructor(public payload: { id: number }) {}
}

export class FollowupReasonsPageRequested implements Action {
  readonly type = FollowupReasonActionTypes.FollowupReasonsPageRequested;

  constructor(public payload: { page: QueryParamsModel }) {}
}

export class FollowupReasonsPageLoaded implements Action {
  readonly type = FollowupReasonActionTypes.FollowupReasonsPageLoaded;

  constructor(
    public payload: { reasons: FollowupReason[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class FollowupReasonsPageCancelled implements Action {
  readonly type = FollowupReasonActionTypes.FollowupReasonsPageCancelled;
}

export class FollowupReasonsPageToggleLoading implements Action {
  readonly type = FollowupReasonActionTypes.FollowupReasonsPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class FollowupReasonsActionToggleLoading implements Action {
  readonly type = FollowupReasonActionTypes.FollowupReasonsActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export type FollowupReasonActions =
  | FollowupReasonDeleted
  | FollowupReasonOnServerDeleted
  | FollowupReasonsPageLoaded
  | FollowupReasonsPageCancelled
  | FollowupReasonsPageToggleLoading
  | FollowupReasonsPageRequested
  | ThrowFollowupReasonError
  | FireFollowupReasonSuccess
  | FollowupReasonsActionToggleLoading;
